var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"img-view",on:{"click":_vm.bigImg}},[_c('p',{staticClass:"img-layer"}),_c('p',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.imgSrc,"alt":""}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }